import { useQuery } from '@tanstack/react-query'
import { getDormantProjects } from '../services/api.js'

export function useDormantProjects(params = {}) {
  const clean = Object.fromEntries(
    Object.entries(params).filter(([, v]) => v !== '' && v != null)
  )
  return useQuery({
    queryKey: ['dormantProjects', clean],
    queryFn: () => getDormantProjects(clean),
    staleTime: 60_000,
  })
}
